<template>
  <div v-if="!online && daySinceOffline > 30" class="absolute inset-0 z-50 bg-Black/60 backdrop-blur-sm"></div>
  <div v-if="!online"
    class="z-[51] flex h-view-padding items-center justify-center rounded-b-md bg-Error text-center text-p2 font-bold tracking-wide text-White md:-mt-view-padding xl:text-p1">
    <span v-if="daySinceOffline < 2">{{ $t('general.offline') }}</span>
    <span v-else-if="daySinceOffline < 16">{{
      fixi18nReplacment($t('general.offline_days'), daySinceOffline)
      }}</span>
    <span v-else-if="daySinceOffline < 31">{{
      fixi18nReplacment($t('general.offline_15days'), daySinceOffline)
      }}</span>
    <span v-else>{{ $t('general.offline_30days') }}</span>
  </div>
</template>
<script setup lang="ts">
import { useOnline } from '@vueuse/core'
import { useInterval } from '@vueuse/core'

const online = useOnline()
const dateincache = await useCachDate()
const daySinceOffline = ref(0)

// calculate date since dateincache
function recalculateDate() {
  if (import.meta.client) {
    const date = new Date(dateincache.value)
    const now = new Date()
    const diffTime = Math.abs(now.getTime() - date.getTime())
    daySinceOffline.value = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  }
}

onMounted(() => {
  recalculateDate()
}),
  useIntervalFn(
    () => {
      recalculateDate()
    },
    1000 * 60 * 3 /* 3 minutes */,
  )

// This is needed because of the i18n saving in the index db see cms.ts
function fixi18nReplacment(str: string, replacements: string | number): string {

  //replace all strings that are wrapped in [] with the value of replacements
  return str.replace(/\[(.*?)\]/g, (match, p1) => {
    return replacements.toString()
  })
}
</script>
